import {Fancybox} from '@fancyapps/ui';
import '../../../node_modules/@fancyapps/ui/dist/fancybox/fancybox.css';
import {swiperStffSlider, swiperBookingSlider, showBookingModalDateDuration, updateDuration, memberMennu} from './common';



document.addEventListener('DOMContentLoaded', function() {
    
    swiperStffSlider(".swiper-staff-js");
    swiperBookingSlider('.swiper-staff-bookingJS')
    
    showBookingModalDateDuration('.bookingDate', '.durationValue', '.getBookingDate', '.btn-save-date');

    updateDuration('.selectDuration', '.durationValue', '.btn-save-duration', '.btn-save-time', '.bookTime', '.bookType', '.outcall-address', '.btH', '.btM', '.btMom', '.btn-save-address');

    memberMennu('.header-min', 'main', '.footer-main', '.menu-dashboard-wrap');

    Fancybox.bind('[data-fancybox="galleryPremium"]');
});
